import graph from "@irati/utils/services/graph"
import {GlobalTenant} from "@irati/types"
import setIfNotSet from "@irati/utils/setIfNotSet"
import {APIRequestConfig} from "@irati/utils/services/API"
import {toString as tenantQuery} from "./queries/Tenant"
import globalErrorHandler from "./errroHandlers/global"

interface KnownTenants {
  [key: string]: Promise<GlobalTenant>
}

const knownTenants: KnownTenants = {}

export function getGlobalTenant(subdomain: string, options: APIRequestConfig = {}): Promise<GlobalTenant> {
  if (!knownTenants[subdomain]) {
    const variables = {subdomain}

    setIfNotSet(options, "ignoreMaintenance", true)
    options.unAuth = true

    knownTenants[subdomain] = graph({query: tenantQuery, variables, operationName: "GlobalTenant"}, options)
      // toggle region
      .catch(globalErrorHandler)
      // if we still fail, clear knownTenant to allow retry
      .catch((err) => {
        delete knownTenants[subdomain]
        throw err
      })
      .then((data) => data.globalTenant)
  }

  return knownTenants[subdomain]
}

export default {
  getGlobalTenant
}
